import React from 'react';
import {Button, CircularProgress} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import { hasDecimalNumbers } from '../../../util/GeneralUtil';

const useStyles = makeStyles(() => ({
  nextStep: {
    background: '#EC5269',
    color: 'white',
    textTransform: 'none',
    borderRadius: 10,
    width: 160,
    margin: '1%'
  }
}));

export default function PayButton({amount, handlePayAmount, paymentLoader}) {
  const classes = useStyles();
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.nextStep}
      onClick={() => handlePayAmount()}>
      Pay - ${(hasDecimalNumbers(amount) ? amount.toFixed(2) : amount)}
      {paymentLoader && (
        <CircularProgress
          style={{marginLeft: 10, color: 'white'}}
          size="1rem"
        />
      )}
    </Button>
  );
}
